export default __webpack_public_path__ + "static/media/call.7f2f15e6.svg";